const LEGACY_TENANT_IDS = new Set([1]);

export const isLegacyTenantId = (clienteId) => LEGACY_TENANT_IDS.has(Number(clienteId));
